

















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ValidationObserver } from 'vee-validate'

@Component({
  name: 'ModalDialog',
  components: {
    ValidationObserver
  }
})
export default class ModalDialog extends Vue {
  @Prop({ required: false, default: null }) width!: string | null
  @Prop({ required: false, default: true }) wrapForm!: boolean

  submitForm() {
    this.$emit('submit')
  }
}
